import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigUp: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M9 18v-6H5l7-7 7 7h-4v6H9z' }]],
];

export default ArrowBigUp;
